<template>
  <div>
    <!-- 媒资榜导入的对话框 -->
    <el-dialog class="edit-dialog custom-dialog-min-width" title="乐播榜媒资导入" :visible.sync="dialogVisible" width="50%" :modal-append-to-body="true"
      append-to-body close-on-click-modal @closed="handleClose">
      <div class="search-container">
        <div>
          <el-input size="small" clearable v-model="searchParams.name" placeholder="媒资名称"
            style="width: 120px;margin-right: 10px;"></el-input>
          <el-select size="small" clearable v-model="searchParams.type" placeholder="媒资类型"
            style="width: 120px;margin-right: 10px;">
            <!-- 1-电视剧；2-电影；3-综艺；4-少儿 -->
            <el-option label="电视剧" :value="1"></el-option>
            <el-option label="电影" :value="2"></el-option>
            <el-option label="综艺" :value="3"></el-option>
            <el-option label="少儿" :value="4"></el-option>
          </el-select>
          <el-select size="small" clearable v-model="searchParams.status" placeholder="状态"
            style="width: 120px;margin-right: 10px;">
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="0"></el-option>
          </el-select>
          <el-select size="small" clearable v-model="searchParams.sourceType" placeholder="来源"
            style="width: 120px;margin-right: 10px;">
            <!-- 1-腾讯资源; 2-优酷资源; 3-爱奇艺资源; 8-Bilibili -->
            <el-option label="腾讯资源" :value="1"></el-option>
            <el-option label="优酷资源" :value="2"></el-option>
            <el-option label="爱奇艺资源" :value="3"></el-option>
            <el-option label="Bilibili" :value="8"></el-option>
          </el-select>
        </div>
        <div>
          <el-button size="small" type="primary" @click="search">搜索</el-button>
        </div>
      </div>
      <el-table :data="list" tooltip-effect="dark" ref="table" style="margin-top: 20px" height="470" row-key="id"
        @select="selectionChange" @select-all="selectAll">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="ID" prop="id">
        </el-table-column>
        <el-table-column label="媒资图片" prop="coverImage">
          <template slot-scope="scope">
            <ImageIframe style="width: 75px; height: 70px;" v-if="ifShowIframe" :url="scope.row.coverImage">
            </ImageIframe>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="媒资名称" prop="name">
        </el-table-column>
        <el-table-column label="媒资类型" prop="type">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">电视剧</span>
            <span v-else-if="scope.row.type === 2">电影</span>
            <span v-else-if="scope.row.type === 3">综艺</span>
            <span v-else-if="scope.row.type === 4">少儿</span>
          </template>
        </el-table-column>
        <el-table-column label="播放来源" prop="sourceType">
          <template slot-scope="scope">
            <span v-if="scope.row.sourceType === 1">腾讯资源</span>
            <span v-else-if="scope.row.sourceType === 2">优酷资源</span>
            <span v-else-if="scope.row.sourceType === 3">爱奇艺资源</span>
            <span v-else-if="scope.row.sourceType === 8">Bilibili</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">上架</span>
            <span v-else-if="scope.row.status === 0">下架</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="媒资标签" prop="tagName">
        </el-table-column>
        <el-table-column label="最后更新时间" prop="updateTime">
        </el-table-column>
      </el-table>
      <el-popover placement="top-start" width="400" trigger="click">
        <div>已选记录列表</div>
        <div>已选择 ( {{ selectedCount }} ) <span class="all-option" @click="clearAll">&nbsp;全部移除</span> </div>
        <el-table :data="selectedList">
          <el-table-column show-overflow-tooltip label="ID" prop="id">
          </el-table-column>
          <el-table-column label="媒资图片" prop="coverImage">
            <template slot-scope="scope">
              <!-- <el-image :src="scope.row.coverImage" style="width: 50px;height: 50px;" fit="contain"></el-image> -->
              <ImageIframe style="width: 75px; height: 70px;" v-if="ifShowIframe" :url="scope.row.coverImage">
              </ImageIframe>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="媒资名称" prop="name">
          </el-table-column>
          <el-table-column label="媒资类型" prop="type">
            <template slot-scope="scope">
              <span v-if="scope.row.type === 1">电视剧</span>
              <span v-else-if="scope.row.type === 2">电影</span>
              <span v-else-if="scope.row.type === 3">综艺</span>
              <span v-else-if="scope.row.type === 4">少儿</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="播放来源" prop="sourceType">
            <template slot-scope="scope">
              <span v-if="scope.row.sourceType === 1">腾讯资源</span>
              <span v-else-if="scope.row.sourceType === 2">优酷资源</span>
              <span v-else-if="scope.row.sourceType === 3">爱奇艺资源</span>
              <span v-else-if="scope.row.sourceType === 8">Bilibili</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="status">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">上架</span>
              <span v-else-if="scope.row.status === 0">下架</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="媒资标签" prop="tagName">
          </el-table-column>
          <el-table-column show-overflow-tooltip label="最后更新时间" prop="updateTime">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="remove(scope.row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="reference">
          已选择 ( <span class="select-count">{{ selectedCount }}</span> )
        </div>
      </el-popover>
      <!-- 分页组件 -->
      <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
        :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入确认" :visible.sync="importVisible" width="40%" :modal-append-to-body="true" append-to-body
      close-on-click-modal @closed="importHide">
      <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
        <div style="margin-bottom: 20px;">已选择媒资{{ selectedCount }}个，重复媒资{{ repeatRes }}个</div>
        <el-button size="small" type="primary" @click="submitImport">确认导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElementPagination from '@/components/ElementPagination';
import Message from '@/components/Message';
import { getLeboMediaList, checkRepeat, importMedia } from '@/api/listContentManage/index'
import ImageIframe from "@/views/markManage/img_iframe.vue"
export default {
  name: 'WebSaaSImport',
  components: {
    ElementPagination,
    ImageIframe
  },
  data() {
    return {
      importVisible: false,
      ifShowIframe: false,
      /** 对话框是否可见 */
      dialogVisible: false,
      /** 搜索参数 */
      searchParams: {
        /** 媒资名称 */
        name: '',
        /** 媒资类型 */
        type: '',
        /** 状态 */
        status: '',
        /** 来源 */
        sourceType: '',
        current: 1,
        size: 10,
        total: 0,
      },
      /** 媒资榜列表数据 */
      list: [],
      /** 已选择数量 */

      /** 已经选中的列表 */
      selectedList: [],
      /** 已经选中的ids */
      selectedIds: [],

      /** 重复媒资 */
      repeatRes: null
    };
  },
  computed: {
    /** 已选择数量 */
    selectedCount() {
      return this.selectedList.length ? this.selectedList.length : 0;
    },
  },
  methods: {
    //^ ^--------------对话框内部事件-------------^ ^
    /** 确认导入的事件 */
    async submitImport() {
      const params = [...this.selectedIds]
      const { data } = await importMedia(params);
      console.log('导入的响应', data);

      if (data.code === 200) {
        Message.success('导入成功');
        this.$emit('reload')
        this.importHide()
        this.hide();
      }
    },
    /** 保存的事件 */
    async save() {
      console.log('save', this.selectedIds);
      const params = [...this.selectedIds]
      const { data: repeatRes } = await checkRepeat(params)
      console.log('repeatRes', repeatRes);
      if (repeatRes.code === 200) {
        this.$set(this, 'repeatRes', repeatRes.data)
        this.importVisible = true
      }

    },
    /** 移除 */
    remove(row) {
      console.log('移除', row);
      const index = this.selectedIds.findIndex(id => id === row.id);
      if (index !== -1) {
        this.selectedIds.splice(index, 1);
        const itemIndex = this.selectedList.findIndex(item => item.id === row.id);
        if (itemIndex !== -1) {
          this.selectedList.splice(itemIndex, 1);
        }
      }
      this.$nextTick(() => {
        this.list.forEach((item) => {
          if (item.id === row.id) {
            console.log("回填选中态", item);
            this.$refs.table.toggleRowSelection(item, false);
          }
        });
      });
    },
    /** 清空所有 */
    clearAll() {
      this.selectedList = [];
      this.selectedIds = [];
      this.$refs.table.clearSelection();
    },
    /** 选择改变 */
    selectionChange(val, row) {
      console.log("选择change", val, row);
      /** 判断id是否在selectIds中 */
      const index = this.selectedIds.findIndex((id) => id === row.id);
      if (index !== -1) {
        // 如果存在，就删除
        this.selectedIds.splice(index, 1);
        const itemIndex = this.selectedList.findIndex(
          (item) => item.id === row.id
        );
        if (itemIndex !== -1) {
          this.selectedList.splice(itemIndex, 1);
        }
      } else {
        // 如果不存在，就添加
        this.selectedIds.push(row.id);
        this.selectedList.push(row);
      }
      console.log("selectedIds", this.selectedIds);
    },
    /** 全选 */
    selectAll(val) {
      console.log("全选", val);
      if (val) {
        this.selectedList = [...val];
        this.selectedIds = val.map((item) => item.id);
      } else {
        this.selectedList = [];
        this.selectedIds = [];
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.selectedList = [];
      this.selectedIds = [];
    },
    show() {
      this.dialogVisible = true;
      this.getList()

    },
    hide() {
      this.dialogVisible = false;
    },
    importHide() {
      this.importVisible = false
      this.repeatRes = null
    },
    //^ ^--------------分页相关-------------^ ^
    /** 搜索 */
    async search() {
      this.searchParams.current = 1;
      /** 更新数据 */
      this.getList();
      Message.success("搜索成功");
    },
    /** 分页 */
    async getList() {
      console.log("getList");
      this.ifShowIframe = false;
      /** 请求数据 */
      const { data } = await getLeboMediaList(this.searchParams);
      console.log("分页的响应", data);
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
      this.ifShowIframe = true;
      /** 回填选中态 */
      this.$nextTick(() => {
        this.list.forEach((item) => {
          if (this.selectedIds.includes(item.id)) {
            console.log("回填选中态", item);
            this.$refs.table.toggleRowSelection(item, true);
          }
        });
      });
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.select-count {
  color: #1890ff;
  cursor: pointer;
}

.all-option {
  color: #1890ff;
  cursor: pointer;
}
</style>
